var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
	'row',
	_vm.gutter ? 'row-no-gutter' : '',
	_vm.line ? 'row-line' : ''
]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }